// This file is generated by FlowerTypesGenerator.php
// Do not edit it manually
// Mirrors Article::FLOWER_TYPES on the backend: cannabis and its prepared variants. These are the types
// that are measured in gram and that carry flower attributes such as Genetik, Strain and Restfeuchte.
export const FLOWER_ARTICLE_TYPES = ["cannabis", "readymade", "milled", "smalls"] as const

export type FlowerArticleType = (typeof FLOWER_ARTICLE_TYPES)[number]

export function isFlowerArticleType(type: string | null | undefined): type is FlowerArticleType {
    return FLOWER_ARTICLE_TYPES.includes(type as FlowerArticleType)
}
